import React, { useEffect } from 'react';
import PageHeader from '@atlaskit/page-header';
import Page, { Grid, GridColumn } from '@atlaskit/page';
import Button from '@atlaskit/button';
import { useStateValue } from "../../contexts/AppContext";
import ReactTable from "react-table";
import CrossCircleIcon from "@atlaskit/icon/glyph/cross-circle";
import axios from "axios";
import { getApiData } from "../../actions";
import Wrapper from "../../components/Wrapper";

const Ranks = () => {
  const [state, dispatch] = useStateValue();
  const tableName = "ranks";

  useEffect(() => {
    getApiData(tableName, "/api/rank", dispatch);
  }, []);

  return (
    <Page>
      <PageHeader>Rangovi utrka</PageHeader>
      <Grid spacing='cosy'>
        <GridColumn medium={10} />
        <GridColumn medium={2}>
          <Button appearance='primary' href='/ranks/new'>
            Novi rang utrke
          </Button>
        </GridColumn>
      </Grid>
      <Grid spacing='cosy'>
        <GridColumn medium={12}>
        {state.apiData[tableName] && 
          <Wrapper>
            <ReactTable
              showPagination={state.apiData[tableName].length > 20}
              data={(state.apiData[tableName])}
              columns={[
                {
                  Header: "Id",
                  accessor: "id",
                  maxWidth: 50
                },
                {
                  Header: "Naziv",
                  accessor: "name",
                  maxWidth: 700
                },
                {
                  Header: "Bodovi",
                  accessor: "points",
                  maxWidth: 100
                },
                {
                  Header: "Izbriši",
                  accessor: "delete",
                  maxWidth: 100,
                  Cell: row => (
                    <Button
                      onClick={async () => {
                        await axios.delete("/api/rank", { params: { id: row.original.id } });
                        getApiData(tableName, "/api/rank", dispatch);
                      }}
                    >
                  <CrossCircleIcon />
                </Button>
                  )
                }
              ]}
              defaultSorted={[
                {
                  id: "id",
                  desc: false
                }
              ]}
              defaultPageSize={10}
              className="-striped -highlight"
            />
          </Wrapper>
        }
        </GridColumn>
      </Grid>
    </Page>
  );
};

export default Ranks;
